import { z } from "zod";

/**
 * WordPress category document schema
 * Path: organizations/{orgId}/domains/{domainId}/wordpress_categories/{wp_category_id}
 */
export const WordPressCategorySchema = z.object({
  wp_category_id: z.number(),
  name: z.string(),
  slug: z.string(),
  description: z.string().default(""),
  parent: z.number().default(0),
  count: z.number().default(0),
});

export type WordPressCategory = z.infer<typeof WordPressCategorySchema>;

export const parseWordPressCategory = (data: unknown): WordPressCategory =>
  WordPressCategorySchema.parse(data);

export const safeParseWordPressCategory = (data: unknown) =>
  WordPressCategorySchema.safeParse(data);
